// src/index.ts
import { ApolloLink, Observable } from "@apollo/client";
import { isLiveQueryOperationDefinitionNode } from "@n1ru4l/graphql-live-query";
import { applyLiveQueryJSONPatch } from "@n1ru4l/graphql-live-query-patch-json-patch";
import { applyAsyncIterableIteratorToSink } from "@n1ru4l/push-pull-async-iterable-iterator";
import { Repeater } from "@repeaterjs/repeater";
import { print } from "graphql";
import ReconnectingEventSource from "reconnecting-eventsource";
var isLiveQuery = (definition, variables) => !!definition && isLiveQueryOperationDefinitionNode(definition, variables);
var makeEventStreamSource = (url) => {
  const eventSource = new ReconnectingEventSource(url);
  return applyLiveQueryJSONPatch(
    new Repeater(async (push, end) => {
      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        push(data);
        if (eventSource.readyState === 2) {
          end();
        }
      };
      eventSource.onerror = (error) => {
        end(error);
      };
      await end;
      eventSource.close();
    })
  );
};
var SSELink = class extends ApolloLink {
  constructor(options) {
    super();
    this.options = options;
  }
  request(operation) {
    const headers = Object.entries(this.options.headers ?? {}).reduce(
      (headers2, [key, value]) => ({ ...headers2, [key]: value }),
      {}
    );
    const searchParams = new URLSearchParams({
      ...headers,
      query: print(operation.query),
      operationName: operation.operationName || "",
      variables: JSON.stringify(operation.variables || {})
    });
    const url = new URL(this.options.uri);
    url.search = searchParams.toString();
    const client = makeEventStreamSource(url.toString());
    return new Observable(
      (sink) => applyAsyncIterableIteratorToSink(client, sink)
    );
  }
};
export {
  SSELink,
  isLiveQuery
};
